<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true" [contentClasses]="['floatingLabelContainer']">
        <p-floatlabel variant="on">
            <input id="name" type="text" pInputText formControlName="name" />
            <label for="name">Name</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
            <textarea id="description" rows="5" cols="30" pInputTextarea formControlName="description"></textarea>
            <label for="description">Description</label>
        </p-floatlabel>

        @if (enableOo8Feature) {
            <p-floatlabel variant="on">
                <p-select
                    [options]="oo8Organizations"
                    formControlName="oo8_organization_uuid"
                    optionLabel="name"
                    optionValue="uuid"
                    inputId="oo8_organization_uuid"
                    id="oo8_organization_uuid"
                    appendTo="body"
                    [showClear]="true"
                ></p-select>
                <label for="oo8_organization_uuid">OO8 Organization</label>
            </p-floatlabel>
        }
    </app-ibase-cru-modal-content>
</form>
